import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Icon, Button } from 'shared/components';

import theme from './AvatarUploadFailureModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
};

const AvatarUploadFailureModal = ({ intl, onCancel }) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <FormattedMessage id="modal.editUserAvatarFailureModal.header" defaultMessage="** File is not an image" />
      <div onClick={ onCancel } className={ theme.closingIconContainer }>
        <Icon name="naked-x" />
      </div>
    </div>

    <div className={ theme.body }>
      <FormattedMessage
        id="modal.editUserAvatarFailureModal.body"
        defaultMessage="** The file you are trying to upload is not an image file, select a different file and try again"
      />
    </div>

    <div className={ theme.footer }>
      <Button
        label={ intl.formatMessage({ id: 'const.button.close', defaultMessage: '** Close' }) }
        labelColor="blackMedium"
        buttonType="naked"
        onClick={ onCancel }
      />
    </div>
  </div>
);

AvatarUploadFailureModal.propTypes = propTypes;

export default AvatarUploadFailureModal;
